import store from '@/store';
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 5,
    searchMenuSpan: 4,
    searchLabelWidth: 120,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            search: true,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: true,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
        },
        {
            label: "保证金抵扣金额",
            prop: "securityDepositDeductionAmount",
            type: "input",
        },
        {
            label: "抵扣期数",
            prop: "currentTenancy",
            type: "input",
            formatter: (val, value, label) => {
                return value ? value + "/" + val["tenancy"] : "-";
            },
        },
        {
            label: "抵扣状态",
            prop: "deductionStatus",
            type: "select",
            search: true,
            hide: true,
            dicData: [{
                    label: "已抵扣",
                    value: 1,
                },
                {
                    label: "已退回",
                    value: 2,
                },
            ],
        },
        {
            label: "抵扣状态",
            // prop: "deductionStatus",
            prop: "status",
            type: "select",
            search: false,
            dicData: [{
                    label: "已抵扣",
                    value: 1,
                },
                {
                    label: "已退回",
                    value: 2,
                },
            ],
        },
        {
            label: "客户是否还租",
            prop: "repaymentStatus",
            type: "select",
            search: true,
            hide: true,
            dicData: [{
                    label: "是",
                    value: true,
                },
                {
                    label: "否",
                    value: false,
                },
            ],
        },
        {
            label: "客户是否还租",
            // prop: "repaymentStatus",
            prop: "whetherRepaymentStatus",
            type: "select",
            search: false,
            dicData: [{
                    label: "是",
                    value: true,
                },
                {
                    label: "否",
                    value: false,
                },
            ],
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
          label: "进件编号",
          prop: "businessCode",
          display: false,
          search: true,
      },
    ],
};
